import request from "@/request";

/**
 * 文件由 gen-api 自动生成，如有疑问，请联系 teacher-wang 
 * 接口 [系统配置] https://yapi.sugonup.com/project/1206/interface/api/cat_4059
 */

export interface GetSystemSetResultOther {
	/** ai客服key */
	kefu: string;
}

/** 跨域视频助办-系统配置详情-系统配置详情 响应主体 */
export interface GetSystemSetResult {
	update_datetime?: string;
	icon?: string;
	other?: GetSystemSetResultOther;
	add_datetime?: string;
	uuid?: string;
	name?: string;
	login_status: boolean;
	is_polaris: boolean;
	logout_url: string;
}

/** 跨域视频助办-系统配置详情-系统配置详情 https://yapi.sugonup.com/project/1206/interface/api/15410 */
export const getSystemSet = () => request.get<GetSystemSetResult>(`/api/v1/system_set`, );

export interface PostSystemSetBodyOther {
}

/** 跨域视频助办-修改系统配置-修改系统配置 请求主体 */
export interface PostSystemSetBody {
	name?: string;
	other?: PostSystemSetBodyOther;
	icon?: string;
	/** 客户端是否需要登录 t需要f不需要 */
	login_status: boolean;
}

/** 跨域视频助办-修改系统配置-修改系统配置 响应主体 */
export interface PostSystemSetResult {

}

/** 跨域视频助办-修改系统配置-修改系统配置 https://yapi.sugonup.com/project/1206/interface/api/15419 */
export const postSystemSet = (body: PostSystemSetBody) => request.post<PostSystemSetResult>(`/api/v1/system_set`, body);
